import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, ChevronDown } from "lucide-react";

export const PAGE_SIZE = 20;

function pageList(cur, total) {
  const set = new Set([1, total, cur - 1, cur, cur + 1].filter((p) => p >= 1 && p <= total));
  const arr = [...set].sort((a, b) => a - b);
  const out = [];
  arr.forEach((p, i) => { if (i && p - arr[i - 1] > 1) out.push(`gap-${p}`); out.push(p); });
  return out;
}

export const LoadMoreButton = ({ onClick, from, to, total }) => (
  <div className="mt-8 flex flex-col items-center gap-2" data-testid="catalog-load-more">
    <Button variant="outline" size="lg" onClick={onClick} className="gap-2 rounded-full px-8" data-testid="catalog-load-more-btn">
      Ver más talleres <ChevronDown className="w-4 h-4" />
    </Button>
    <p className="text-xs text-muted-foreground" data-testid="catalog-range">Viendo {from}–{to} de {total}</p>
  </div>
);

export const CatalogPager = ({ page, totalPages, onPage, from, to, total }) => (
  <nav className="mt-8 flex flex-col items-center gap-3" aria-label="Paginación de talleres" data-testid="catalog-pager">
    <div className="flex items-center gap-1.5 flex-wrap justify-center">
      <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPage(page - 1)} className="gap-1 rounded-full" data-testid="pager-prev-btn">
        <ChevronLeft className="w-4 h-4" /> Anterior
      </Button>
      {pageList(page, totalPages).map((p) => typeof p === "string" ? (
        <span key={p} className="px-1 text-muted-foreground">…</span>
      ) : (
        <button key={p} onClick={() => onPage(p)} data-testid={`pager-page-${p}`} aria-current={p === page ? "page" : undefined}
          className={`h-9 min-w-9 px-2 rounded-full text-sm font-medium transition-colors ${p === page ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`}>
          {p}
        </button>
      ))}
      <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => onPage(page + 1)} className="gap-1 rounded-full" data-testid="pager-next-btn">
        Siguiente <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
    <p className="text-xs text-muted-foreground" data-testid="catalog-range">Viendo {from}–{to} de {total}</p>
  </nav>
);
